import { useMemo } from 'react'
import { z } from 'zod'

import { requiredSelection, requiredString } from '../../../../../app/_components/form/zodSchemas'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'

export const useAddLogoValidationSchema = () => {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const validationSchema = useMemo(() => {
    return z.object({
      logoFileId: requiredString(fixtures.validationErrorMessages.requiredLogo),
      logoPlacement: requiredSelection(fixtures.validationErrorMessages.requiredLogoPlacement),
    })
  }, [fixtures])

  return validationSchema
}
